/**
 * @generated SignedSource<<66eb0204d9034a9eea2827fccdbc609a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetRoutineOverview_widgetRoutineOverview$data = {
  readonly id: string;
  readonly title: string;
  readonly " $fragmentType": "WidgetRoutineOverview_widgetRoutineOverview";
};
export type WidgetRoutineOverview_widgetRoutineOverview$key = {
  readonly " $data"?: WidgetRoutineOverview_widgetRoutineOverview$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetRoutineOverview_widgetRoutineOverview">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetRoutineOverview_widgetRoutineOverview",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    }
  ],
  "type": "WidgetRoutineOverview",
  "abstractKey": null
};

(node as any).hash = "2686a6ad55fb32e7ae58402e093893f7";

export default node;
